(function (VisiApp, $, undefined) {

    $(document).ready(function(){

        $('.auto-submit-on-change').each(function(){
            var $this = $(this);

            $this.find('input, select, textarea, checkbox').change(function(){
               $this.submit();
            });
        });
    });

    // VisiApp.initSimplePickerWithTime = function (dateTimePicker) {
    //
    //     // console.log('daterangepicker is not installed');
    //     // return;
    //     dateTimePicker.daterangepicker({
    //         singleDatePicker: true,
    //         timePicker24Hour: true,
    //         timePicker: true,
    //         timePickerIncrement: 15,
    //         locale: {
    //             format: 'DD.MM.YYYY HH:mm'
    //         }
    //     }, function (start, end, label) {
    //         dateTimePicker.val(start.format('DD.MM.YYYY H:mm'));
    //         dateTimePicker.trigger('change');
    //     });
    // };
    // VisiApp.initSimplePicker = function (dateTimePicker) {
    //
    //     console.log($);
    //     console.log($(dateTimePicker));
    //
    //     $(dateTimePicker).daterangepicker({
    //         "singleDatePicker": true,
    //         "autoUpdateInput": false,
    //         "locale": {
    //             "format": "DD.MM.YYYY",
    //             "applyLabel": "Apply",
    //             "cancelLabel": "Cancel",
    //             "fromLabel": "From",
    //             "toLabel": "To",
    //             "customRangeLabel": "Custom",
    //             "daysOfWeek": [
    //                 "Su",
    //                 "Mo",
    //                 "Tu",
    //                 "We",
    //                 "Th",
    //                 "Fr",
    //                 "Sa"
    //             ],
    //             "monthNames": [
    //                 "January",
    //                 "February",
    //                 "March",
    //                 "April",
    //                 "May",
    //                 "June",
    //                 "July",
    //                 "August",
    //                 "September",
    //                 "October",
    //                 "November",
    //                 "December"
    //             ],
    //             "firstDay": 1
    //         },
    //         "opens": "left",
    //         "drops": "down",
    //         "buttonClasses": "btn btn-sm",
    //         "applyClass": "btn-success",
    //         "cancelClass": "btn-default"
    //     }, function (start, end, label) {
    //         dateTimePicker.val(start.format('DD.MM.YYYY'));
    //         dateTimePicker.trigger('change');
    //         console.log("New date range selected: " + start.format('YYYY-MM-DD') + ' to ' + end.format('YYYY-MM-DD') + ' (predefined range: ' + label + ")");
    //     });
    // };
    // VisiApp.initDateRangePicker = function (dateTimePicker) {
    //     dateTimePicker.daterangepicker({
    //         "autoUpdateInput": false,
    //         "locale": {
    //             "format": "DD.MM.YYYY",
    //             "applyLabel": "Apply",
    //             "cancelLabel": "Cancel",
    //             "fromLabel": "From",
    //             "toLabel": "To",
    //             "customRangeLabel": "Custom",
    //             "daysOfWeek": [
    //                 "Su",
    //                 "Mo",
    //                 "Tu",
    //                 "We",
    //                 "Th",
    //                 "Fr",
    //                 "Sa"
    //             ],
    //             "monthNames": [
    //                 "January",
    //                 "February",
    //                 "March",
    //                 "April",
    //                 "May",
    //                 "June",
    //                 "July",
    //                 "August",
    //                 "September",
    //                 "October",
    //                 "November",
    //                 "December"
    //             ],
    //             "firstDay": 1
    //         },
    //         "opens": "left",
    //         "drops": "down",
    //         "buttonClasses": "btn btn-sm",
    //         "applyClass": "btn-success",
    //         "cancelClass": "btn-default"
    //     }, function (start, end, label) {
    //         dateTimePicker.val(start.format('DD.MM.YYYY') + ' - ' + end.format('DD.MM.YYYY'));
    //         dateTimePicker.trigger('change');
    //         console.log("New date range selected 2: " + start.format('YYYY-MM-DD') + ' to ' + end.format('YYYY-MM-DD') + ' (predefined range: ' + label + ")");
    //     });
    // };
    // VisiApp.initDateYearPicker = function (dateTimePicker) {
    //     dateTimePicker.daterangepicker({
    //         "autoUpdateInput": true,
    //         "singleDatePicker": true,
    //         "locale": {
    //             "format": "YYYY",
    //             "applyLabel": "Apply",
    //             "cancelLabel": "Cancel",
    //             "fromLabel": "From",
    //             "toLabel": "To",
    //             "customRangeLabel": "Custom",
    //             "daysOfWeek": [
    //                 "Su",
    //                 "Mo",
    //                 "Tu",
    //                 "We",
    //                 "Th",
    //                 "Fr",
    //                 "Sa"
    //             ],
    //             "monthNames": [
    //                 "January",
    //                 "February",
    //                 "March",
    //                 "April",
    //                 "May",
    //                 "June",
    //                 "July",
    //                 "August",
    //                 "September",
    //                 "October",
    //                 "November",
    //                 "December"
    //             ],
    //             "firstDay": 1
    //         },
    //         "opens": "left",
    //         "drops": "down",
    //         "buttonClasses": "btn btn-sm",
    //         "applyClass": "btn-success",
    //         "cancelClass": "btn-default"
    //     }, function (start, end, label) {
    //         //console.log("New date range selected 2: " + start.format('YYYY-MM-DD') + ' to ' + end.format('YYYY-MM-DD') + ' (predefined range: ' + label + ")");
    //     });
    // };
    //
    // //Public Method
    VisiApp.initDatePicker = function (dateTimePicker, autoInput) {
        dateTimePicker.daterangepicker({
            "singleDatePicker": true,
            "autoUpdateInput": (autoInput !== undefined ? autoInput : true),
            "locale": {
                "format": "DD.MM.YYYY",
                "applyLabel": "Apply",
                "cancelLabel": "Cancel",
                "fromLabel": "From",
                "toLabel": "To",
                "customRangeLabel": "Custom",
                "daysOfWeek": [
                    "Su",
                    "Mo",
                    "Tu",
                    "We",
                    "Th",
                    "Fr",
                    "Sa"
                ],
                "monthNames": [
                    "January",
                    "February",
                    "March",
                    "April",
                    "May",
                    "June",
                    "July",
                    "August",
                    "September",
                    "October",
                    "November",
                    "December"
                ],
                "firstDay": 1
            },
            "opens": "left",
            "drops": "down",
            "buttonClasses": "btn btn-sm",
            "applyClass": "btn-success",
            "cancelClass": "btn-default"
        }, function (start, end, label) {
            dateTimePicker.val(start.format('DD.MM.YYYY'));
            dateTimePicker.trigger('change');
            console.log("New date range selected: " + start.format('YYYY-MM-DD') + ' to ' + end.format('YYYY-MM-DD') + ' (predefined range: ' + label + ")");
        });
    };
    //
    // VisiApp.initDateTimePickerWithMinDay = function (dateTimePicker, minDate) {
    //     dateTimePicker.daterangepicker({
    //         "singleDatePicker": true,
    //         "autoUpdateInput": true,
    //         "minDate": minDate,
    //         "locale": {
    //             "format": "DD.MM.YYYY",
    //             "applyLabel": "Apply",
    //             "cancelLabel": "Cancel",
    //             "fromLabel": "From",
    //             "toLabel": "To",
    //             "customRangeLabel": "Custom",
    //             "daysOfWeek": [
    //                 "Su",
    //                 "Mo",
    //                 "Tu",
    //                 "We",
    //                 "Th",
    //                 "Fr",
    //                 "Sa"
    //             ],
    //             "monthNames": [
    //                 "January",
    //                 "February",
    //                 "March",
    //                 "April",
    //                 "May",
    //                 "June",
    //                 "July",
    //                 "August",
    //                 "September",
    //                 "October",
    //                 "November",
    //                 "December"
    //             ],
    //             "firstDay": 1
    //         },
    //         "opens": "left",
    //         "drops": "down",
    //         "buttonClasses": "btn btn-sm",
    //         "applyClass": "btn-success",
    //         "cancelClass": "btn-default"
    //     }, function (start, end, label) {
    //         console.log("New date range selected: " + start.format('YYYY-MM-DD') + ' to ' + end.format('YYYY-MM-DD') + ' (predefined range: ' + label + ")");
    //     });
    // };


    var tables = [];
    var tableCount = 0;
    VisiApp.registerDataTable = function ($table) {
        tables[tableCount] = $table;
        tableCount = tableCount + 1;
    };
    VisiApp.redrawDataTables = function () {
        for (var i = 0; i < tableCount; i++) {
            tables[i].search(tables[i].search()).draw(false);
        }
    };

    VisiApp.submitForm = function (form, callback) {
        console.log('submit form');

        form.find('.modal-error').html('');
        form.find('button[type=submit]').addClass('m-progress').attr('disabled', '');


        var formData = new FormData(form[0]);

        $.ajax({
            url: form.attr('action'),
            data: formData,
            dataType: 'multipart/form-data',
            type: 'POST',
            processData: false,
            contentType: false,
        })
            .always(function (data) {

                if (data.responseText != undefined) {
                    var response = JSON.parse(data.responseText);

                    if (data.status === 200) {


                        if (response.success) {
                            // toastr['success'](response.success);
                            window.vueApp.$notify.success(response.success);
                        }
                        if (response.error) {
                            // toastr['error'](response.error);
                            window.vueApp.$notify.error(response.error);
                        }

                        if (typeof callback === "function") {
                            callback(response);
                        }
                    }

                    if (data.status === 422) { //Unprocessable Entity - Validation error
                        console.log(422);

                        var err = [];
                        for(var field in response.errors){
                            // console.log(field, response[field]);
                            err.push(response.errors[field][0]);
                        }
                        form.find('.modal-error').html(err.join('<br>'));

                    }
                    form.find('button[type=submit]').removeClass('m-progress').removeAttr('disabled');

                }
            });

        return false;
    };

    // VisiApp.changeModalWithForm = function (form, method, action) {
    //
    //     form.find('.modal-error').html('');
    //     form.find('button').addClass('m-progress').attr('disabled', '');
    //
    //     _targetModal.find('.modal-content modal-body').html("Loading ...");
    //
    //     var formData = new FormData(form[0]);
    //
    //     $.ajax({
    //         url: (action ? action : form.attr('action')),
    //         data: formData,
    //         dataType: 'multipart/form-data',
    //         type: (method ? method : 'GET'),
    //         processData: false,
    //         contentType: false
    //     })
    //         .always(function (data) {
    //             if (data.responseText != undefined) {
    //
    //                 if (Base.IsJsonString(data.responseText)) {
    //                     var response = JSON.parse(data.responseText);
    //                     if (!response.error) {
    //
    //                     } else {
    //                         if (Array.isArray(response.error)) {
    //                             _targetModal.find('.modal-error').html(response.error.join('<br>'));
    //                         } else {
    //                             _targetModal.find('.modal-error').html(response.error);
    //                         }
    //                     }
    //                 } else {
    //                     _targetModal.find('.modal-content').html(data.responseText);
    //                     _targetModal.modal('show');
    //
    //                 }
    //             } else {
    //                 _targetModal.find('.modal-content').html(data);
    //                 _targetModal.modal('show');
    //
    //             }
    //             VisiApp.redrawDataTables();
    //
    //         });
    //
    //     return false;
    //
    // };


}(window.VisiApp = window.VisiApp || {}, jQuery));

$(document).ready(function(){

    $('.select2').select2({
        allowClear: true,
        placeholder: "Select ..."
    });

});

(function (Lang, undefined) {

    Lang.get = function (key, replace = {}) {
        return Lang.trans(key, replace);
    };

    Lang.trans = function (key, replace = {}) {
        let translation = key.split('.').reduce((t, i) => t[i] || null, window.translations);

        for (let placeholder in replace) {
            translation = translation.replace(`:${placeholder}`, replace[placeholder]);
        }

        return translation;
    };

    Lang.trans_choice = function(key, count = 1, replace = {})
    {
        let translation = key.split('.').reduce((t, i) => t[i] || null, window.translations).split('|');

        translation = count > 1 ? translation[1] : translation[0];

        for (var placeholder in replace) {
            translation = translation.replace(`:${placeholder}`, replace[placeholder]);
        }

        return translation;
    }

}(window.Lang = window.Lang || {}));

// function isArray(what) {
//     return Object.prototype.toString.call(what) === '[object Array]';
// }





// WEBPACK FOOTER //
// ./resources/assets/js/app/global.js